import { Flex, Inline, Text } from '@vtex/admin-ui'
import { DefaultProps, GenericIcon } from 'typings'
import { styles } from './styles'

type Props = DefaultProps & {
  Icon: GenericIcon
  label: string
}

export function SelectorHeader(props: Props) {
  const { label, Icon, children } = props

  return (
    <Flex align="center" justify="space-between">
      <div className={styles.selectorHeader}>
        <Icon className={styles.selectorHeaderIcon} />
        <Text variant="action2">{label}</Text>
      </div>
      <Inline align="center">{children}</Inline>
    </Flex>
  )
}
